<template>
  <v-layout row wrap class="custom-group antisnipe-layout form-section-gap" no-gutters>
    <v-flex xs12 md5 class="pr-md-4">
      <v-layout
        no-gutters
        class="custom-group antisnipe-field form-field"
        column
        justify-center
        align-start
      >
        <div class="anti-sniping-toggle">
          <input
            id="enable-anti-sniping"
            type="checkbox"
            :checked="enabled"
            @change="onToggle"
          />
          <label for="enable-anti-sniping" class="placeholder mb-0">Enable anti-sniping</label>
        </div>
        <template v-if="enabled">
          <span class="placeholder">Anti-sniping window (in minutes):</span>
          <input
            class="custom-input anti-sniping-input"
            type="number"
            :value="extensionPeriodMinutes"
            placeholder="5"
            @input="onInput"
          />
          <span class="anti-sniping-hint">
            If a bid is placed within this window before closing, the auction will be extended,
            resetting the countdown to this duration.
          </span>
          <span v-if="errExtension" class="error-input antisnipe-error"
            >Use 0 or a positive number</span
          >
        </template>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { AUCTION_LABEL_ANTI_SNIPING_WINDOW } from '@/constants/auction';
import AuctionFormInfoTooltip from '@/components/forms/auctionForm/AuctionFormInfoTooltip.vue';

export default {
  name: 'AuctionFormReverseAntiSnipe',
  components: { AuctionFormInfoTooltip },
  data() {
    return {
      antiSnipingWindowLabel: AUCTION_LABEL_ANTI_SNIPING_WINDOW,
    };
  },
  props: {
    enabled: { type: Boolean, default: false },
    extensionPeriodMinutes: { type: Number, required: true },
    errExtension: { type: Boolean, default: false },
  },
  methods: {
    onToggle(e) {
      this.$emit('update:enabled', e.target.checked);
    },
    onInput(e) {
      const v = e.target.value === '' ? 0 : Number(e.target.value);
      this.$emit('update:extensionPeriodMinutes', Number.isFinite(v) ? v : 0);
    },
  },
};
</script>

<style scoped>
.antisnipe-layout {
  margin-top: 6px;
}

.antisnipe-field {
  margin-bottom: 8px;
}

.label-with-tooltip {
  display: flex;
  align-items: center;
  gap: 6px;
}

.anti-sniping-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.anti-sniping-toggle input,
.anti-sniping-toggle label {
  cursor: pointer;
}

.anti-sniping-toggle label {
  color: #216169;
  font-size: 12px;
  font-weight: 500;
}

.anti-sniping-input {
  max-width: 180px;
}

.anti-sniping-hint {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #216169;
  text-align: left;
}

.antisnipe-error {
  margin-top: 2px;
  margin-bottom: 2px;
}

</style>
